module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/sparkles-top-superiority.f0f7f9f6.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/sparkles-top-superiority.png
// module id = 2851
// module chunks = 11